import React from 'react';
import FeedbackButton from '../../components/FeedbackButton';
import SaveHeartButton from '../../components/SaveHeartButton';
import VideoPlayer from './VideoPlayer';
import VideoProgressBar from './VideoProgressBar';

/**
 * Read-only video view used when interactive features (Q&A, takeaways)
 * are disabled. Shows just the player, a progress bar, and the save /
 * feedback buttons.
 */
function LiteVideoView({ videoId, channelId, progress, saved }) {
  return (
    <div className="flex flex-col text-left">
      <VideoPlayer
        disableInteractiveFeatures
        feedbackContentIds={[videoId, channelId]}
        onProgress={progress.handleProgressUpdate}
        onReady={progress.handlePlayerReady}
        onTiming={progress.handleTimingUpdate}
        showFeedbackButton={false}
        videoId={videoId}
      />
      <VideoProgressBar progress={progress.videoProgress} />
      <div className="flex justify-end gap-2 mt-2 px-2">
        <SaveHeartButton
          isSaved={saved.isSaved}
          onClick={saved.handleSaveToggle}
          disabled={saved.isSaving}
        />
        <FeedbackButton contentIds={[videoId, channelId]} />
      </div>
    </div>
  );
}

export default LiteVideoView;
